import { StatusTrackingDto } from '../../../shared/modules/status-tracking/dtos/status-tracking.dto';
import { VehicleStatusEnum } from '../enums/vehicle-status.enum';

/**
 * Vehicle availability DTO
 */
export class VehicleAvailabilityDto {
  id!: number;
  isAvailable!: boolean;
  nextAvailableFrom?: Date | null;
  nextAvailableTo?: Date | null;
  statusTracking?: StatusTrackingDto<VehicleStatusEnum>[] | null;
}
